import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './CourseDetailPage.css';
import CourseHeader from './CourseHeader';
import CourseInfo from './CourseInfo';
import CourseTabs from './CourseTabs';
import CourseChapters from './CourseChapters';
import CourseQA from './CourseQA';
import CourseReview from './CourseReview';

// 模拟课程数据，实际应用中应从API获取
const coursesData = [
  {
    id: '1',
    title: 'MMO状态同步组队战斗分布式演服案例课程',
    subtitle: '二叉堆数据结构实战运用(PriorityQueue)',
    instructor: 'Frank老师',
    rating: 4.0,
    reviewCount: 28,
    studentCount: 356,
    originalPrice: 1024.00,
    price: 256.00,
    coverImage: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/system/2021/09-08/10072086c6c5152962.png?version=21.3.2',
    isLimited: true,
    intro: `本课程将带您深入学习React的核心概念和高级特性，包括：
    <ul>
      <li>React Hooks 全面掌握</li>
      <li>Context API 和状态管理</li>
      <li>性能优化最佳实践</li>
      <li>TypeScript 与 React 结合</li>
    </ul>
    <title>适合人群：</title>
    <p>具有 JavaScript 基础，想要提升 React 开发水平的学习者。</p>
    <title>课程特色：</title>
    <p>1. 系统全面：覆盖 React 核心概念和高级特性</p>
    <p>2. 实战导向：通过实际案例讲解，帮助您快速上手</p>
    <p>3. 深入浅出：理论与实践相结合，易于理解</p>
    <title>课程收获：</title>
    <p>1. 掌握 React 核心概念和高级特性</p>
    <p>2. 提升 React 开发水平和项目实战能力</p>
    <p>3. 为后续深入学习 React 打下坚实基础</p>
    <title>课程大纲：</title>
    <ul>
      <li>第一章: React 基础概念和项目结构</li>
      <li>第二章: React Hooks 全面掌握</li>
      <li>第三章: Context API 和状态管理</li>
      <li>第四章: 性能优化最佳实践</li>
      <li>第五章: TypeScript 与 React 结合</li>
    </ul>
    <img src="https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2023/03-20/125406ed3e67105666.png" alt="课程大纲">
    `,
    courseFeatures: [
      '3600分钟高清视频',
      '5个可下载资源文件',
      '移动端、PC端同步观看',
      '学习讨程习问解答',
      '专属QQ、微信交流群'
    ],
    chapters: [
      {
        id: '1',
        title: '第一章: Unity客户端基础业务框架搭建',
        completed: true,
        sections: [
          { id: '001', title: '小节01: 001MMO案例课程最终效果Demo演示', duration: '05:06', completed: true },
          { id: '002', title: '小节02: 002MMO案例课程核心技术要点概述', duration: '07:29', completed: true },
          { id: '003', title: '小节03: 003演示整套工作流程', duration: '03:56', completed: true },
          { id: '004', title: '小节04: 004学习注意事项', duration: '09:28', completed: true },
        ]
      },
      {
        id: '2',
        title: '第二章: NetCore服务器基础业务框架搭建',
        completed: false,
        sections: [
          { id: '005', title: '小节01: 001MMO案例课程最终效果Demo演示', duration: '05:06', completed: true },
          { id: '006', title: '小节03: 003演示整套工作流程', duration: '03:56', completed: false },
          { id: '007', title: '小节04: 004学习注意事项', duration: '09:28', completed: false },
        ]
      }
    ]
  },
  // 可以添加更多课程数据...
];

const CourseDetailPage = () => {
  const { courseId } = useParams();
  const [activeTab, setActiveTab] = useState('intro');
  const [courseData, setCourseData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 模拟从API获取数据
    const fetchCourseData = () => {
      // 实际应用中这里应该是API调用
      const foundCourse = coursesData.find(course => course.id === courseId);
      
      // 模拟网络延迟
      setTimeout(() => {
        setCourseData(foundCourse || coursesData[0]); // 如果找不到，使用第一个课程
        setLoading(false);
      }, 100);
    };

    fetchCourseData();
  }, [courseId]);

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  if (!courseData) {
    return <div className="error">未找到课程信息</div>;
  }

  return (
    <div className="course-detail-page">
      <CourseHeader 
        breadcrumb={['游戏开发', '课程详情']}
        title={courseData.title}
        subtitle={courseData.subtitle}
      />
      
      {/* 添加封面图区域 */}
      <div className="course-cover-container">
        <img 
          src={courseData.coverImage} 
          alt={courseData.title}
          className="course-cover-image"
        />
        <div className="course-cover-overlay">
          <div className="cover-stats">
            <div className="stat-item">
              <i className="icon-play"></i>
              <span className="icon-play">3600分钟课程</span>
            </div>
            <div className="stat-item">
              <i className="icon-user"></i>
              <span className="icon-play">{courseData.studentCount} 名学员</span>
            </div>
            <div className="stat-item">
              <i className="icon-star"></i>
              <span className="icon-play">{courseData.rating} 星</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="course-detail-container">
        <div className="course-detail-main">
          <div className="course-tabs-wrapper">
            <CourseTabs 
              activeTab={activeTab} 
              setActiveTab={setActiveTab} 
            />
          </div>
          
          {activeTab === 'intro' && (//课程介绍
            <div className="course-intro">
              <div dangerouslySetInnerHTML={{ __html: courseData.intro }} />
            </div>
          )}
          
          {activeTab === 'catalog' && (//课程目录
            <CourseChapters chapters={courseData.chapters} />
          )}
          
          {activeTab === 'qa' && (//课程问答
            <CourseQA />
          )}

          {activeTab === 'review' && (//课程评价
            <div className="course-review">
              <CourseReview />
            </div>
          )}
        </div>
        
        <div className="course-detail-sidebar">
          <CourseInfo 
            instructor={courseData.instructor}
            rating={courseData.rating}
            reviewCount={courseData.reviewCount}
            studentCount={courseData.studentCount}
            originalPrice={courseData.originalPrice}
            price={courseData.price}
            isLimited={courseData.isLimited}
            features={courseData.courseFeatures}
          />
        </div>
      </div>
    </div>
  );
};

export default CourseDetailPage;